export const APP_NAME = "The Best SIF";
